var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabList),function(tab){return _c('div',{key:tab.key,staticClass:"tab",class:_vm.getTabClass(tab),on:{"click":function($event){return _vm.OpenTab(tab.key)}}},[_vm._v(" "+_vm._s(tab.label)+" "),(tab.tooltip)?_c('span',{staticClass:"tab-tooltip"},[_vm._v(_vm._s(tab.tooltip))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }